import './Header.css';
import {Link} from "react-router-dom";

const Header = () => {
    return (
        <div>
            <nav>
                <a href="/">
                    <img className="logo" src="images/logo.svg" alt="logo"/>
                </a>
            </nav>
            <div className="dropdown">
                <button type="button">
                    <img  className="menu" src="images/menusvg.svg" alt="menu"/>
                    {/*<span>cancel</span>*/}
                </button>
                {/*<nav className="dropdown-content">*/}
                {/*    <ul>*/}
                {/*        <li><Link to='/'>Home</Link></li>*/}
                {/*        <li><Link to='/over'>Over Ons</Link></li>*/}
                {/*        <li><Link to='/blog'>Blog</Link></li>*/}
                {/*        <li><Link to='/contact'>Contact</Link></li>*/}
                {/*    </ul>*/}
                {/*</nav>*/}
            </div>
        </div>
    );

}

export default Header;
